module.exports = __webpack_public_path__ + "img/inspiration_02.fc7a5f90.png";